import React, { useEffect } from 'react'
import homedashboard from "../../../../assets/images/homedashboard.svg";
import articleexpertdashboard from "../../../../assets/images/articleexpertdashboard.svg";
import mypaymentdashboard from "../../../../assets/images/intarestdashboard.svg"
import asktheexpertdashboard from "../../../../assets/images/asktheexpertdashboard.svg";
import articledashboard from "../../../../assets/images/articledashboard.svg";
import logoutdashboard from "../../../../assets/images/logoutdashboard.svg";
import accountsettingdashboard from "../../../../assets/images/accountsettingdashboard.svg";
import { useTranslation } from "react-i18next";
import usermanualdashboard from "../../../../assets/images/usermanualdashboard.svg";
import dashboardmenu from "../../../../assets/images/dashboardmenu.svg";
import { Link } from "react-router-dom";
import { NEW_URL, baseURL } from '../../../../constants/applicationConstants';
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import axios from 'axios'
import '../sidebar/sidebar.model.css';

const SideBarsJsx = (props) => {
  const history = useHistory();
  const { t } = useTranslation();

  const {
    response
  } = props;

  useEffect(() => {
    const callDetails = () => {
      let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
      let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
      const instUserId = localStorage.getItem('instUserId') ?? '';
  
      let url = `${baseURL}/institute/${instituteId}/details`
      let secondary_url = `${baseURL}/detailsInstituteUser/${instUserId}`
  
      const adminLoginData = localStorage.getItem('adminLoginData');
      
      // Create cache key
      const cacheKey = `instituteDetails_`;
      
      // Check if data exists in localStorage
      const cachedData = localStorage.getItem(cacheKey);
      
      if (cachedData) {
        // Use cached data
        const parsedData = JSON.parse(cachedData);
        
        if (!adminLoginData && !parsedData?.data?.isPermanentPasswordSet) {
          history.push("/saveNewPassword");
        }
      } else {
        // Make API call only if no cached data exists
        axios.get(instUserId ? secondary_url : url, {
          headers: { 'x-access-token': token }
        }).then(res => {
          // Store the response in localStorage
          localStorage.setItem(cacheKey, JSON.stringify(res.data));
          
          if (!adminLoginData && !res.data?.data?.isPermanentPasswordSet) {
            history.push("/saveNewPassword");
          }
        }).catch(err => {
          console.error('API call failed:', err);
        })
      }
    }
    callDetails()
  },[history]);

  
  const logout = () => {
    swal({
      title: "Are you sure you want to Logout ?",
      icon: "warning",
      buttons: [
        'Continue',
        'Logout'
      ],
      dangerMode: true,
    }).then(function (isConfirm) {
      if (isConfirm) {
        // Clear all localStorage items including cached data
        localStorage.removeItem("token");
        localStorage.removeItem("loginAs");
        localStorage.removeItem("auth");
        localStorage.removeItem("masterID");
        localStorage.removeItem("expertId");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("loginData");
        localStorage.removeItem("expertData");
        localStorage.removeItem("customerId");
        localStorage.removeItem("planName");
        localStorage.removeItem("legalName");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("description");
        localStorage.removeItem("flowName");
        localStorage.removeItem("flowType");
        localStorage.removeItem("subscriptionPlanId");
        localStorage.removeItem("planTypeID");
        localStorage.removeItem("planData");
        localStorage.removeItem("flowName");
        localStorage.removeItem("flowType");
        localStorage.removeItem("verificationStatus");
        localStorage.removeItem('VerifyInstituteID');
        localStorage.removeItem('AdminFlow');
        localStorage.removeItem('VerifyExpertID');
        localStorage.removeItem("comingFrom");
        
        // Clear cached institute details
        const cacheKey = `instituteDetails_`;
        localStorage.removeItem(cacheKey);

        history.push("/");
        window.location.reload()
      } else {
        //   swal("Cancelled", "Your imaginary file is safe :)", "error");
      }
    })
  }

  
  return (
    <>
     <div className="dashboard-container maincustomerdashboard">
      <div className="dashboardleftpanel">
        <div className="dashboardlinkpop">
          <div className="dashboard-container maincustomerdashboard main">
            <div className="dashboardleftpanel">
            <div className="d-none d-sm-block">
              <div className="text-column">
                <div className="userdetails mt-3">
                  <div className="dashboardlogo">
                    <img
                      src={!response?.imageUrl
                        ? `https://ui-avatars.com/api/?name=${response?.name}&rounded=true`
                        : `${NEW_URL}/${response?.imageUrl}`}
                      alt={'icon'}
                    />
                  </div>
                  <div className="responsename"> {`${response?.name}`} <Link to={`/institute/${response?.formattedLegalName}`} target="_blank" rel="noreferrer" className="viewprofilebtn">{t("COMMON.VIEWPROFILE")}</Link></div>
                </div>

                <div className="dashboardlink dashboardtext mydash">
                  <ul className="dashboardinner">
                    <li >
                      <Link to={'/dashBoard'}>
                        <span className="menusideimage"><img className="leftborder" src={homedashboard} alt={'icon'} /></span>  <p className={` ${window.location.href?.toLowerCase().includes('dashboard') ? 'activetext' : ""}`}>Dashboard</p>
                      </Link>
                    </li>
                    <li >
                      <Link to={'/myExpert'}>
                        <span className="menusideimage"><img className="leftborder" src={asktheexpertdashboard} alt={'icon'} /></span><p className={`${window.location.href?.toLowerCase().includes('myexpert') || window.location.href?.toLowerCase().includes('unregistered') ? 'activetext' : ''}`}>My Experts</p>
                      </Link>
                    </li>
                    <li >
                      <Link to={'/myWorkspace'}>
                        <span className="menusideimage"><img className="leftborder" src={articleexpertdashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('myworkspace') ? 'activetext' : ''}`}>My Workspace</p>
                      </Link>
                    </li>
                    <li >
                      <Link to={'/myBlog'}>
                        <span className="menusideimage"><img className="leftborder" src={articledashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('myblog') ? 'activetext' : ''}`}>My Articles</p>
                      </Link>
                    </li>
                    <li >
                      <Link to={'/myAccounts'}>
                        <span className="menusideimage"><img className="leftborder" src={accountsettingdashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('myaccounts') ? 'activetext' : ''}`}>My Account</p>
                      </Link>
                    </li>
                    <li >
                      <Link to={'/myPayment'}>
                        <span className="menusideimage"><img className="leftborder" src={mypaymentdashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('mypayment') ? 'activetext' : ''}`}>My Payment</p>
                      </Link>
                    </li>
                    <li><a href={'/Institutionsusermanual.pdf'} target="_blank"  rel="noopener noreferrer"><span className="menusideimage"><img src={usermanualdashboard} alt={'icon'} /></span><p>User Manual</p></a></li>
                    <li onClick={logout}>
                    <div className="sidebarlogout"> <span className="menusideimage"><img className="leftborder" src={logoutdashboard} alt={'icon'} /></span><p>Logout</p></div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
           
            <div className="d-block d-lg-none d-sm-none d-md-none">
              <div className="dashboardlinkpop">
                <nav className="navbar">
                  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"><img src={dashboardmenu} alt="menuicon" /></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarText">
                  <ul className="navbar-nav dashboardinner">
                    <li className="nav-item">
                      <Link to={'/dashBoard'} className={` ${window.location.href?.toLowerCase().includes('dashboard') ? 'active' : ""}`}>
                       <p className={` ${window.location.href?.toLowerCase().includes('dashboard') ? 'activetext' : ""}`}>
                          <span className="menusideimage"><img className="leftborder" src={homedashboard} alt={'icon'} /></span>  
                        Dashboard</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to={'/myExpert'} className={`${window.location.href?.toLowerCase().includes('myexpert') || window.location.href?.toLowerCase().includes('unregistered') ? 'active' : ''}`}>
                        <p className={`${window.location.href?.toLowerCase().includes('myexpert') || window.location.href?.toLowerCase().includes('unregistered') ? 'activetext' : ''}`}><span className="menusideimage"><img className="leftborder" src={asktheexpertdashboard} alt={'icon'} /></span>
                        My Experts</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to={'/myWorkspace'}  className={`${window.location.href?.toLowerCase().includes('myworkspace') ? 'active' : ''}`}>
                         <p className={`${window.location.href?.toLowerCase().includes('myworkspace') ? 'activetext' : ''}`}>
                           <span className="menusideimage"><img className="leftborder" src={articleexpertdashboard} alt={'icon'} /></span> 
                       My Workspace</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to={'/myBlog'} className={`${window.location.href?.toLowerCase().includes('myblog') ? 'active' : ''}`}>
                        <p className={`${window.location.href?.toLowerCase().includes('myblog') ? 'activetext' : ''}`}>
                          <span className="menusideimage"><img className="leftborder" src={articledashboard} alt={'icon'} /></span> 
                        My Articles</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to={'/myAccounts'} className={`${window.location.href?.toLowerCase().includes('myaccounts') ? 'active' : ''}`}>
                        <p className={`${window.location.href?.toLowerCase().includes('myaccounts') ? 'activetext' : ''}`}>
                          <span className="menusideimage"><img className="leftborder" src={accountsettingdashboard} alt={'icon'} /></span> 
                        My Account</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to={'/myPayment'} className={`${window.location.href?.toLowerCase().includes('mypayment') ? 'active' : ''}`}>
                      <p className={`${window.location.href?.toLowerCase().includes('mypayment') ? 'activetext' : ''}`}> <span className="menusideimage"><img className="leftborder" src={mypaymentdashboard} alt={'icon'} /></span> My Payment</p>
                      </Link>
                    </li>
                    <li className="nav-item"><a href={'/Institutionsusermanual.pdf'} target="_blank" rel="noreferrer"><p><span className="menusideimage"><img src={usermanualdashboard} alt={'icon'} /></span>User Manual</p></a></li>


                    <li className="nav-item" onClick={logout}><div className="sidebarlogout">
                      <p><span className="menusideimage"><img src={logoutdashboard} alt={'icon'} /></span>Logout</p>
                      </div>
                    </li>
                    <li>
                    <div className="userdetails">
                  <div className="dashboardlogo">
                    <img
                      src={!response?.imageUrl
                        ? `https://ui-avatars.com/api/?name=${response?.firstName}+${response?.lastName}&rounded=true`
                        : `${NEW_URL}/${response?.imageUrl}`}
                      alt={'icon'}
                    />
                  </div>
                  <div className="responsename"> {`${response?.name}`} <Link to={`/institute/${response?.formattedLegalName}`} target="_blank" rel="noreferrer" className="viewprofilebtn">{t("COMMON.VIEWPROFILE")}</Link></div>
                </div>
                    </li>
                  </ul>
                    
                  </div>
                </nav>
                
              </div>
            </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>

  );
};

export default SideBarsJsx;